import { RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'

import { createAppRouter } from './router'

// タブを開いたまま古い JavaScript が使われ続けるのを防ぐため、旧 client と同じ間隔で更新する
setTimeout(
  () => {
    location.reload()
  },
  6 * 60 * 60 * 1000,
)

const container = document.getElementById('root')
if (container === null) {
  throw new Error('#root element not found')
}
createRoot(container).render(<RouterProvider router={createAppRouter()} />)
